import { Component, ComponentSearcher, Panel, Table } from "@mcleod/components";
import { PermsUserAndGroupCache } from "./PermsUserAndGroupCache ";
import { Alignment, ModelRow } from "@mcleod/core";

export class GroupSecureItemTooltip extends Panel {
    private table: Table;
    constructor(userGroupId: string, permsUserCache: PermsUserAndGroupCache) {
        super({ width: 350, height: "40vh", padding: 0 });
        this.table = this.addTable(userGroupId, permsUserCache);
        this.add(this.table);
    }

    private addTable(userGroupId: string, permsUserCache: PermsUserAndGroupCache) {
        const table = new Table({ fillHeight: true, fillRow: true,
            rowBorderBottomWidth: 0,
            maxHeight: "40vh",
            columnHeadingsVisible: false,
            columns: [{ cell: { field: "name" } }]
        });
        table.filterTextbox?.setProps({width: 165});
        table.addlSearcherCallback = () => [new ComponentSearcher("name"), new ComponentSearcher("id")];

        const userOrGroup = permsUserCache.userGroups[userGroupId];
        userOrGroup?.get("group_membership")?.forEach(member => {
            const memberId = member.user_id;
            const memberName = permsUserCache.getDisplayName("U", memberId);
            table.addRow(new ModelRow(null, false, { name: memberName, id: memberId }), null, {display: true });
        });
        if (table.isEmpty())
        table.emptyCaption = "No users are assigned to this group";
        return table;
    }

    public static addTooltipCallback(component: Component, userGroupId: string, permsUserCache: PermsUserAndGroupCache) {
        if (component == null)
            return null;
        component.tooltipCallback = () => {
            const tooltip = new GroupSecureItemTooltip(userGroupId, permsUserCache);
            return component.showTooltip(tooltip,
                {
                    position: Alignment.LEFT
                },
                {
                    themeKey: "quickInfo",
                    color: null,
                    borderLeftColor: null,
                    borderLeftWidth: null,
                    borderRightColor: "warning.dark",
                    borderRightWidth: 12,
                }
            );
        };
    }
}